export default __webpack_public_path__ + "static/media/DadBirthday_03.d124871b.png";